import {
  EDIT_PAYMENT_INFO,
  IGNORE_RENT_AMOUNT_CHANGE,
  SAVE_DATE_OF_BIRTH,
  SAVE_FIRST_NAME,
  SAVE_LAST_NAME,
  SAVE_PAYMENT_INFO,
  SHOW_RENT_AMOUNT_CHANGE,
  UPDATE_ARRAY_USER_TOKEN,
  UPDATE_CREDIT_TRACKING_ENROLLMENT_STATUS,
} from '@renter-hub/constants/actionTypes';

export const savePaymentInfo = (paymentInfo): { [key: string]: any } => ({
  type: SAVE_PAYMENT_INFO,
  paymentInfo,
});

export const saveDateOfBirth = (dateOfBirth): { [key: string]: any } => ({
  type: SAVE_DATE_OF_BIRTH,
  dateOfBirth,
});

export const saveFirstName = (firstName): { [key: string]: any } => ({
  type: SAVE_FIRST_NAME,
  firstName,
});

export const saveLastName = (lastName): { [key: string]: any } => ({
  type: SAVE_LAST_NAME,
  lastName,
});

export const editPaymentInfo = (): { [key: string]: string } => ({
  type: EDIT_PAYMENT_INFO,
});

export const ignoreRentAmountChange = (): { [key: string]: string } => ({
  type: IGNORE_RENT_AMOUNT_CHANGE,
});

export const showRentAmountChange = (): { [key: string]: string } => ({
  type: SHOW_RENT_AMOUNT_CHANGE,
});

export const updateArrayUserToken = (arrayUserToken: string | null) => ({
  type: UPDATE_ARRAY_USER_TOKEN,
  payload: { arrayUserToken },
});

export const updateCreditTrackingEnrollmentStatus = (enrollmentStatus: string) => ({
  type: UPDATE_CREDIT_TRACKING_ENROLLMENT_STATUS,
  payload: { enrollmentStatus },
});
